import { Component, EventEmitter, Input, Output, ChangeDetectorRef, OnDestroy, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ConfigConstants } from '../../config/config-constants';
import { BarcodeScannerService } from '../../services/barcode-scanner/barcode-scanner.service';
import { ApplicationIdentifier } from '@evorait/pace-components';
import { finalize, take, takeUntil } from 'rxjs/operators';
import { faArrowLeft, faClipboardList, faDownload } from '@fortawesome/free-solid-svg-icons';
import { ConnectivityService } from '../../services/connectivity/connectivity.service';
import { Subject, timer } from 'rxjs';
import { BarcodeScanResult } from '../../services/barcode-scanner/barcode-scanner.const';

const FLASH_MILLISECONDS = 100;

@Component({
    selector: 'pace-core-barcode-scanner-modal',
    templateUrl: './barcode-scanner-modal.component.html',
    styleUrls: ['./barcode-scanner-modal.component.scss'],
})
export class BarcodeScannerModalComponent implements OnInit, OnDestroy {
    @Input()
    public pattern: string | undefined;
    @Input()
    public appId: ApplicationIdentifier = ConfigConstants.ApplicationIdentifier.Default;
    @Input()
    public clipboardAccessible = true;

    @Output()
    public scanCompleted = new EventEmitter<BarcodeScanResult>();

    public clipboardOpened = false;
    public barcodes$ = this.barcodeScannerService.barcodeClipboard$;
    public loading = false;
    public isOnline$ = this.connectivityService.isOnline$;
    public readonly fetchIcon = faDownload;
    public readonly backIcon = faArrowLeft;
    public readonly clipboardIcon = faClipboardList;
    public isFlashing = false;
    private destroy$ = new Subject<void>();

    public constructor(
        private readonly modalInstance: BsModalRef,
        private readonly connectivityService: ConnectivityService,
        private readonly barcodeScannerService: BarcodeScannerService,
        private readonly cdr: ChangeDetectorRef,
    ) {}

    public ngOnInit(): void {
        this.fetchClipboard();
    }

    public onBarcodeSelected(result: BarcodeScanResult): void {
        this.scanCompleted.emit(result);
        this.scanCompleted.complete();
        this.hideModal();
    }

    public hideModal(): void {
        this.modalInstance.hide();
    }

    public closeClipboard(): void {
        this.clipboardOpened = false;
    }

    public openClipboard(): void {
        this.clipboardOpened = true;
    }

    public fetchClipboard(): void {
        this.loading = true;
        this.barcodeScannerService
            .fetchBarcodeClipboard()
            .pipe(
                take(1),
                finalize(() => {
                    this.loading = false;
                }),
            )
            .subscribe();
    }

    public flash(): void {
        this.isFlashing = true;
        timer(FLASH_MILLISECONDS)
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => {
                this.isFlashing = false;
                this.cdr.detectChanges(); // manually tell Angular to update
            });
    }

    public ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
